export const contentTableConfig = {
  title: '记录列表',
  propList: [
    {prop: 'raffleName', label: '活动名称', minWidth: '80'},
    {prop: 'name', label: '姓名', minWidth: '80'},
    {prop: 'deptName', label: '所属部门', minWidth: '80'},
    {prop: 'amount', label: '中奖金额', minWidth: '80', sortable: 'amount'},
    {prop: 'createdTime', label: '中奖时间', minWidth: '80', sortable: 'createdTime'},
    {prop: 'raffleTypeName', label: '红包类型', minWidth: '80'}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
